import {useEffect, useState} from "react";
import {useTranslation, withTranslation} from "react-i18next";
import localOrSessionStore from "_helpers/localOrSessionStore";
import variables from "_constants/variables";
import {useLocation} from "react-router-dom";
import {xcService} from "_services/xcService";
import comunidades from "../../../../_constants/comunidades";
import endpoint from "shared/endpoints";

// eslint-disable-next-line @typescript-eslint/no-var-requires
const _ = require("lodash");

const QuestsToType = {
    '3º ESO': 'TEK3ESO',
    '4º ESO': 'TEK4ESO',
    '1º Bachillerato': 'TEK1BAC',
    '2º Bachillerato': 'TEK2BAC',
    'FP Grado Básico': 'TEKFPB',
    'FP Grado Medio': 'TEKFPM',
}

function ResponsesTek(props) {
    const {t} = useTranslation();
    const storage = localOrSessionStore({key: variables.REMEMBER});
    const {search} = useLocation();
    const [userQuest, setUserQuest] = useState();
    const [answers, setAnswers] = useState([]);
    const userType = storage.getItem(variables.USER_TYPE);
    const studentUid = new URLSearchParams(search).get('user');
    const [code, setCode] = useState();
    const [course, setCourse] = useState();

    const setQuest = (course) => {
        setUserQuest(QuestsToType[course])
        const answersPath = userType === 'STUDENT' ? endpoint.studentAnswer.getAll(QuestsToType[course]) : `/v1/student/${studentUid}/answers/${QuestsToType[course]}`;

        xcService.getToken(answersPath).then(({data}) => setAnswers(data.data));
    }

    useEffect(() => {

        const mUrl = userType === 'STUDENT' ? `/v1/student/course` : `/v1/student/course/${studentUid}`;

        xcService.getToken(mUrl)
            .then(({data}) => {
                setQuest(data.data.name)
                setCourse(data.data.name)
                return data.data.name
            }).then(course => {

                setCode(QuestsToType[course])
            }
        );
    }, [])


    const showResponse = (item) => {
        if (item.points === 999) {
            if (item.assessment.questionType === "CFGM") {
                return t("tek.questionnaire.checkCFGM")
            }
            if (item.assessment.questionType === "CFGS") {
                return t("tek.questionnaire.checkCFGS")
            }
            if (item.assessment.questionType === "SUBJECT") {
                return t("tek.questionnaire.checkbtx")

            }
            return t("tek.questionnaire.noseguro")

        } else {
            if (item.assessment.questionType === "COMAUT") {
                let mCom = _.filter(
                    comunidades, function (o) {
                        return o.code === item.points;
                    }
                );
                if (mCom && mCom[0]) return mCom[0].name;

                return "";

            } else if (item.assessment.questionType === "MULTIPLE3" || item.assessment.questionType === "MULTIPLE2" || item.assessment.questionType === "MULTIPLE4") {
                let mText = item.subanswers.map(sub => sub.response.question).join(', ')

                return mText
            } else {
                if (item.response) {
                    return item.response?.question
                } else {
                    if (item.degree) {
                        return item.degree.title
                    }
                    if (item.subject) {
                        let mText = item.subject.modality + " - " + item.subject.subject;
                        let order = _.orderBy(item?.subanswers, ["subject.order"], ['asc']);
                        if (order && order[0] && order[1] && order[2]) {
                            mText += "<br>" + t("tek.mimodalidad") + ": " + order[0]?.subject?.subject + " " + t("and") + " " + order[1]?.subject?.subject
                            mText += "<br>" + t("tek.mioptativa") + ": " + order[2]?.subject?.subject
                        }
                        return mText
                    }
                }
            }
        }

    }

    return (
        <div className={"container dasboard-informes"}>
                 <div className={"container-question container-question__end no-gamificado centerResponses"}>
                    <div className={"container-question__auto-margin"}>
                        <div className={"question__header"}>
                            <img className={"question__header-icon"} src={`/assets/img/report.png`}/>
                            <h2>{t("tek.endtitleS")}</h2>
                        </div>
                        <div className={"question__content"}>
                            <div className={"question__content-list"}>
                                {answers && answers.map(item => (
                                    <div className={"list-item"} key={item.id}>
                                        <div className={"list-item-l"}>
                                            <p dangerouslySetInnerHTML={{__html: item.assessment?.question}}/>
                                        </div>
                                        <div className={"list-item-r"}>
                                            <p dangerouslySetInnerHTML={{__html: showResponse(item)}}></p>
                                        </div>
                                    </div>
                                ))}
                            </div>

                        </div>

                </div>
            </div>

        </div>
    )
}

export default withTranslation()(ResponsesTek);


